// extracted by mini-css-extract-plugin
module.exports = {"react-markdown-wrapper":"_2vkFK","reactMarkdownWrapper":"_2vkFK","intersectionSubscriber":"JXCrR","anchor":"_1zqX2","heading":"_131fw","custom-link":"_3IWs5","customLink":"_3IWs5"};